import * as React from 'react';
import { StoreState } from '@ui/store/rootReducer';
import { connect } from 'react-redux';
import { LoadableContent, PageNavigation, Separator } from '@ui/components';
import { RouteComponentProps, withRouter } from 'react-router';
import { Divider, Icon, Input } from 'antd';

import { cityStoresSelectors } from '..';
import Store from '../components/Store';
import * as actions from '../services/actions';

import './Stores.less';

interface StateToProps {
  stores?: any[];
  loading: boolean;
  openCity: any;
}

interface DispatchToProps {
  onLoadStores: (cityId: any) => void;
}

type Props = StateToProps & DispatchToProps & RouteComponentProps;

class Stores extends React.PureComponent<Props> {
  state = {
    filterStoresValue: '',
  };

  componentDidMount(): void {
    const { onLoadStores, match } = this.props;

    const { cityId } = match.params as any;
    onLoadStores(cityId);
  }

  openStore = (storeId: any) => {
    const { history } = this.props;
    history.replace(`/store/${storeId}`);
  };

  onFilterInput = (evt: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      filterStoresValue: evt.target.value,
    });
  };

  render(): React.ReactNode {
    const { loading, openCity, stores = [] } = this.props;

    const { filterStoresValue } = this.state;

    const markets = stores.reduce((result, store) => {
      if (store.market) {
        const market = store.market;
        const key = `market__${market.id}`;
        const resultMarket = result[key];
        return resultMarket
          ? {
            ...result,
            [key]: {
              ...resultMarket,
              stores: [...resultMarket.stores, store],
            },
          }
          : { ...result, [key]: { ...market, stores: [store] } };
      }

      return { ...result, [store.id]: { ...store } };
    }, {});

    return (
      <div className="city-stores">
        <LoadableContent loading={loading}>
          {openCity && (
            <PageNavigation
              style={{ width: '100%' }}
              title={
                <div className="city-stores-panel">
                  <span
                    className="region-name"
                    onClick={() => {
                      this.props.history.goBack();
                    }}
                  >
                    {openCity.region.name}
                  </span>
                  <Separator />
                  <span>{openCity.name}</span>
                  <Separator />
                  <span>Магазины</span>
                </div>
              }
            />
          )}
          <div className="city-stores__input_wrapper">
            <Input onChange={this.onFilterInput} suffix={<Icon type="search" />} />
          </div>
          <div className="city-stores-list">
            {
              // @ts-ignore
              Object.values(markets)
                .reduce((acc: any, curr: any) => {
                  if (curr.stores) {
                    const store = {
                      ...curr,
                      stores: curr.stores.filter((c: any) =>
                        c.name.toLowerCase().includes(filterStoresValue.toLowerCase().trim()),
                      ),
                    };
                    acc.push(store);
                  } else if (curr.name.toLowerCase().includes(filterStoresValue.toLowerCase().trim())) {
                    acc.push(curr);
                  }

                  return acc;
                }, [])
                .map((market: any) => {
                  if (market.stores && !market.stores.length) {
                    return null;
                  }

                  return market.stores ? (
                    <div>
                      <Divider orientation="left">{market.name}</Divider>
                      {market.stores.map((store: any) => (
                        <Store key={store.id} store={store} onOpen={this.openStore} />
                      ))}
                    </div>
                  ) : (
                      <Store key={market.id} store={market} onOpen={this.openStore} />
                    );
                })
            }
          </div>
        </LoadableContent>
      </div>
    );
  }
}

const mapStateToProps = (state: StoreState): StateToProps => ({
  stores: cityStoresSelectors.getStores(state),
  loading: cityStoresSelectors.getLoading(state),
  openCity: cityStoresSelectors.getOpenCity(state),
});

const mapDispatchToProps = {
  onLoadStores: actions.storesRequested,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Stores));



// WEBPACK FOOTER //
// ./src/scenes/CityStores/containers/Stores.tsx